import React from "react";
import { FaPhoneAlt } from "react-icons/fa";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import IntroModal from "../acknowledgements/IntroCarouselModal";
import { RenderTncContent } from "../acknowledgements/RenderTncContent";
import GradientLogo from '../../assets/images/GradientLogo.png';

const Footer = () => {

  const [openTncModal, setOpenTncModal] = React.useState(false);
  const [openIntroModal, setOpenIntroModal] = React.useState(false);

  const handleOpenTncModal = () => setOpenTncModal(true);
  const handleCloseTncModal = () => setOpenTncModal(false);

  const handleOpenIntroModal = () => setOpenIntroModal(true);
  const handleCloseIntroModal = () => setOpenIntroModal(false);

  return (
    <footer className="bg-gray-100 w-full">
      <Dialog open={openTncModal} onClose={handleCloseTncModal} maxWidth="sm" fullWidth>
        <DialogTitle>Terms and Conditions</DialogTitle>
        <DialogContent dividers>
          <RenderTncContent />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseTncModal} variant="contained">
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <IntroModal open={openIntroModal} handleClose={handleCloseIntroModal} />
      <div className="py-8 sm:pb-5 pt-14 sm:pt-10 px-2 md:px-8">
        <div className="flex w-full justify-between flex-col md:flex-row items-center gap-2 md:gap-6 flex-wrap">
          <a
            href="/"
            className="flex items-center text-gray-900 text-3xl font-bold no-underline hover:text-gray-900"
          >
            <img src={GradientLogo} alt="GSB Soirika Logo" style={{ height: '40px', maxWidth: '100%', width: 'auto', marginRight: '10px' }} />
            GSB Soirika
          </a>
          <ul className="flex flex-col md:flex-row text-center space-y-2 sm:space-y-0 sm:space-x-8 items-center justify-center p-0 mb-0">
            <li>
              <div className="sm:flex items-center justify-center gap-2 font-medium text-md md:text-lg text-center hidden">
              <FaPhoneAlt />
              <span>+91 8296919479</span>
              </div>
              <a href="tel:+918296919479" className="flex items-center justify-center gap-2 font-medium text-md md:text-lg text-center underline text-black sm:hidden">
              <FaPhoneAlt />
              <span>+91 8296919479</span>
              </a>
            </li>
            <li>
              <a
                href="/about"
                className="no-underline hover:text-gray-900 text-gray-700 font-medium text-md md:text-lg text-center"
              >
                About
              </a>
            </li>
            <li>
              <a
                href="/successStories"
                className="no-underline hover:text-gray-900 text-gray-700 font-medium text-md md:text-lg text-center"
              >
                Success Stories
              </a>
            </li>
            <li>
              <button
                onClick={handleOpenTncModal}
                className="no-underline hover:text-gray-900 text-gray-700 font-medium text-md md:text-lg text-center bg-transparent border-none cursor-pointer"
              >
                Terms & Conditions
              </button>
            </li>
            <li>
              <button
                onClick={handleOpenIntroModal}
                className="no-underline hover:text-gray-900 text-gray-700 font-medium text-md md:text-lg text-center bg-transparent border-none cursor-pointer"
              >
                Getting Started
              </button>
            </li>
          </ul>
        </div>
        <hr className="my-6 border-gray-200 sm:mx-auto lg:my-8" />
        <p className="text-center">
          Copyright © {new Date().getFullYear()} - All rights reserved by GSB
          Soirika
        </p>
      </div>
    </footer>
  );
};

export default Footer;
